export const sanitizedHTML = (strToSanitize) => {
  if (strToSanitize === undefined) {
    return '';
  }
  let myHTML = strToSanitize.replace(/(<([^>]+)>)/gi, '');
  return myHTML || '';
};
